import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { Auth } from 'src/helper/Auth'
import { store } from 'src/redux/store/store'
import { logoutAction } from 'src/redux/actions/loginAction'

const ScrollToTop = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    const currentPath = location.pathname
    const publicPaths = ['/login', '/register']
    const isLogin = Auth.getToken()
    if (publicPaths.includes(currentPath) && isLogin) {
      Auth.removeToken()
      store.dispatch(logoutAction())
      if (currentPath === publicPaths.lastItem) navigate(currentPath)
    }
  }, [location, navigate])

  // eslint-disable-next-line react/react-in-jsx-scope
  return <>{props.children}</>
}

export default ScrollToTop
